const defaultState = {
    param: {},
    shopChange: {}
  };
  
  export default function loading(state=defaultState, action) {
    let stateCopy = {...state};
      switch(action.type) {
        // 接受上一页参数
          case 'shopChangePass':
            stateCopy.param = action.data
            break;
        // 修改参数
          case 'shopChangeEdit':
            const param = Object.assign(state.param, action.data)
            stateCopy.param = param
            break;
        // 清空参数
          case 'shopChangeClear':
            stateCopy.param = {}
            break;
          default:
              return state;
      }
      return stateCopy;
  }